import format from 'utils/dateFns/format'
import { subWeeks } from 'date-fns'

const now = new Date()
const startDate = subWeeks(now, 2)

export default () => ({
  initial: {
    query: '',
    statuses: [],
    date_from: format(startDate, 'yyyy-MM-dd'),
    date_to: format(now, 'yyyy-MM-dd'),
    agency_client_external_ids: [],
  },
  configuration: {
    query: {
      subbutton: { isVisible: (value = '') => !!value },
      label: 'campaigns_editor::campaigns.filters.query.placeholder',
      placeholder: 'campaigns_editor::campaigns.filters.query.placeholder',
      order: 1,
      type: 'input',
    },
    statuses: {
      subbutton: {
        isVisible: (value = [], breakpoints) =>
          value.length > 0 || !!breakpoints.fb,
      },
      label:
        'campaigns_editor::campaigns.filters.dropdown.items.statuses.label',
      position: 'dropdown',
      type: 'checkbox group',
      optionLabelPrefix:
        'campaigns_editor::campaigns.filters.dropdown.items.statuses.options.',
      options: ['active', 'deleted', 'blocked'],
    },
    agency_client_external_ids: {
      subbutton: {
        isVisible: (value = [], breakpoints) =>
          value.length > 0 || !!breakpoints.fb,
      },
      label:
        'campaigns_editor::campaigns.filters.dropdown.items.agency_client_external_ids.label',
      position: 'dropdown',
      type: 'checkbox group',
      optionLabelPrefix: '',
      options: [],
    },
    datepicker: {
      names: ['date_from', 'date_to'],
      subbutton: {
        // eslint-disable-next-line no-unused-vars
        isVisible: (value = [], breakpoints) => !!breakpoints.sm,
      },
      // @todo нужен общий лейбл а не в пульсе
      label: 'campaigns_editor::campaigns.filters.range.label',
      order: 2,
      type: 'datepicker',
    },
  },
})
